import Vue from 'vue'

Vue.component('cmp-br-user-filter', require('./explorer-support/cmp-br-user-filter').default)
